import { EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
import { createFields } from '../utils/createFields';
import { createValidation } from '../utils/createValidation';
import { SEND_FEEDBACK_BUTTON_TEXT } from '../../../../constants/requestForm/buttonText';
import { createField } from '../utils/createField';
var FIELDS = [EFormFieldsNames.Name, EFormFieldsNames.Phone, EFormFieldsNames.Email,
// Отключаем для редактирования, поскольку ссылка валидируется на предыдущем шаге, её больше нельзя менять.
// Возможно в дальнейшем эта логика будет не нужна, если все лишния поля на этом экране уберём, например.
createField(EFormFieldsNames.OwnerOfferLinkOrId, {
  disabled: true
}), EFormFieldsNames.Message, EFormFieldsNames.Files, EFormFieldsNames.PrivacyPolicyAccepted];
export var MODERATION_FINAL_STEP = {
  code: EStepCodes.ModerationFinal,
  question: {
    code: EQuestionCodes.ModerationFinal,
    title: 'Модерация',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: SEND_FEEDBACK_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};